import MasterplanService from '../../services/MasterplanService'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'
import MasterplanHelper from '../../helpers/MasterplanHelper'
import router from '../../router'
import ProjectsService from '../../services/ProjectsService'
export const namespaced = true

const initialState = {
  masterplans: [],
  selectedMasterplan: null,
  selectedMasterplansNestedMasterplans: []
}

export const state = {
  masterplans: [],
  selectedMasterplan: null,
  selectedMasterplansNestedMasterplans: []
}

export const mutations = {
  SET_MASTERPLANS(state, recs) {
    state.masterplans = MasterplanHelper.getRootMasterplans(recs)
  },
  SET_SELECTED_MASTERPLAN(state, rec) {
    console.log(rec)
    state.selectedMasterplan = rec
  },
  SET_SELECTED_MASTERPLANS_NESTED_MASTERPLANS(state, recs) {
    state.selectedMasterplansNestedMasterplans = recs
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  }
}

export const actions = {
  fetchMasterplans: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ProjectsService.getProjectMasterplans(
      context.rootGetters['ProjectStore/getSelectedProjectId']
    ).then(
      r => {
        context.commit('SET_MASTERPLANS', r.data)

        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_MASTERPLANS', null)

        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  setSelectedMasterplan: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return MasterplanService.getMasterplanById(value)
      .then(
        r => {
          context.commit('SET_SELECTED_MASTERPLAN', r.data)
          if (r.data.parentId === 0) {
            context.dispatch(
              'BreadcrumbsStore/add',
              {
                text: 'MASTERPLAN ',
                name: r.data.name
              },
              { root: true }
            )
            context.commit('SET_LOADING_STATUS', 'idle', { root: true })
          } else {
            context.dispatch(
              'BreadcrumbsStore/add',
              {
                text: 'COMMUNITY ',
                name: r.data.name
              },
              { root: true }
            )
            context.commit('SET_LOADING_STATUS', 'idle', { root: true })
          }
        },
        e => {
          context.commit('SET_SELECTED_MASTERPLAN', null)
          context.commit('SET_LOADING_STATUS', 'idle', { root: true })
          AxiosErrorHandler.handler(e, context, router)
        }
      )
      .then(
        MasterplanService.getNestedMasterplans(value).then(
          r => {
            context.commit(
              'SET_SELECTED_MASTERPLANS_NESTED_MASTERPLANS',
              r.data
            )
            context.commit('SET_LOADING_STATUS', 'idle', { root: true })
          },
          e => {
            context.commit('SET_SELECTED_MASTERPLANS_NESTED_MASTERPLANS', null)
            context.commit('SET_LOADING_STATUS', 'idle', { root: true })
            AxiosErrorHandler.handler(e, context, router)
          }
        )
      )
  },
  addMasterplan: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    await MasterplanService.createMasterplan(value)
    context.dispatch('fetchMasterplans')
  },
  updateMasterplan: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return MasterplanService.updateMasterplan(value).then(
      res => {
        context.commit('SET_SELECTED_MASTERPLAN', res.data)
        if (context.state.selectedMasterplan.parentId === 0) {
          context.dispatch(
            'BreadcrumbsStore/update',
            {
              text: 'MASTERPLAN ',
              name: res.data.name
            },
            { root: true }
          )
        } else {
          context.dispatch(
            'BreadcrumbsStore/update',
            {
              text: 'COMMUNITY ',
              name: res.data.name
            },
            { root: true }
          )
        }
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  deleteMasterplan: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    try {
      await MasterplanService.deleteMasterplan(value)
    } catch (error) {
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(error, context, router)
      throw error
    }
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  }
}

export const getters = {
  getSelectedMasterplanId: state => {
    return state.selectedMasterplan ? state.selectedMasterplan.id : 0
  }
}
